export enum PATH {
  PizzaConfigurator = "/",
  Login = "/log-in",
  Signup = "/sign-up",
  Checkout = "/checkout",
  Orders = "/orders",
}
